import { render } from "./AppPreloader.vue?vue&type=template&id=04dd3f75&scoped=true"
import script from "./AppPreloader.vue?vue&type=script&lang=js"
export * from "./AppPreloader.vue?vue&type=script&lang=js"

import "./AppPreloader.vue?vue&type=style&index=0&id=04dd3f75&lang=scss&scoped=true"

import exportComponent from "C:\\Bohdan\\telesim_test\\telesim-admin-panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04dd3f75"]])

export default __exports__